export default __webpack_public_path__ + "static/media/good-karma.c6664f05.png";